//JavaScript Document
import Vue from "vue";
import VueRouter from "vue-router";
//import Test from "submodule/src/pages/test";
Vue.use(VueRouter);

let router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      component: () => import("@/container/index/index.vue"),
      children: [
        {
          path: "",
          component: () => import("@/container/index/navigation.vue"),
        },
      ],
    },
    {
      path: "/jobLog",
      name: "jobLog",
      component: () => import("@/container/data-development/jobLog.vue"),
    },
    {
      path: "/flowAllDetail",
      name: "flowAllDetail",
      component: () => import("@/component/data-development/flowAllDetail.vue"),
    },

    {
      path: "/index",
      component: () => import("@/container/index/index.vue"),
      children: [
        {
          path: "",
          component: () => import("@/container/index/navigation.vue"),
        },
        {
          path: "find-data",
          component: () => import("@/container/find-data/app.vue"),
        },
        // {
        //   path: "table-detail",
        //   name: "table-detail",
        //   component: () => import("@/container/find-data/tableDetail.vue"),
        // },
        {
          path: "resource-apply",
          name: "resource-apply",
          component: () => import("@/container/find-data/app.vue"),
        },
        {
          path: "data-development",
          component: () => import("@/container/data-development/index.vue"),
          children: [
            {
              path: "",
              //redirect: "/index/data-development/project",
              redirect: "/index/data-development/workflow",
            },
            {
              path: "exchangis",
              name: "exchangis",
              component: () =>
                import("@/container/data-development/exchangis.vue"),
            },
            {
              path: "task",
              name: "task",
              component: () => import("@/container/data-development/task.vue"),
            },
            // {
            //   path: "sql-script",
            //   name: "SQLScript",
            //   component: () =>
            //     import("@/container/data-development/sql-script.vue"),
            // },
            // {
            //   path: "project",
            //   name: "Project",
            //   component: () =>
            //     import("@/container/data-development/project.vue"),
            // },
            {
              path: "workflow",
              name: "workflow",
              // component: () => import("@dss/js/view/workflow/index.vue"),
              component: () =>
                import("@/container/data-development/workflow.vue"),
            },
            {
              path: "ddl",
              name: "ddl",
              component: () => import("@/container/data-development/ddl.vue"),
            },

            {
              path: "udf",
              name: "udf",
              component: () => import("@/container/data-development/udf.vue"),
            },
            {
              path: "script",
              name: "script",
              component: () =>
                import("@/container/data-development/script.vue"),
            },
            // {
            //   path: "new-integration",
            //   name: "NewIntegration",
            //   component: () =>
            //     import("@/container/data-development/new-integration.vue"),
            // },
          ],
        },
        {
          path: "stream-work", //realTime development
          name: "stream-work",
          component: () => import("@/container/streamWork/index.vue"),
        },
        {
          path: "open/query",
          component: () => import("@/container/open/query.vue"),
        },
        {
          path: "open/bi",
          component: () => import("@/container/open/bi.vue"),
        },
        {
          path: "plat-manage",
          component: () => import("@/container/platformManage/index.vue"),
          redirect: "/sendmessage",
          children: [
            {
              //发送消息
              name: "sendmessage",
              path: "/sendmessage",
              component: () =>
                import("@/container/platformManage/sendMessage.vue"),
            },

            {
              // 租户管理
              name: "workspaces",
              path: "/workspaces",
              component: () =>
                import("@/container/platformManage/workspaces.vue"),
            },
            {
              // 数据源管理
              name: "datasource",
              path: "/datasource",
              component: () =>
                import("@/container/authorization/datasource.vue"),
            },
            {
              // 数据源模板管理
              name: "template",
              path: "/template",
              component: () => import("@/container/authorization/template.vue"),
            },
            {
              // 资源管理器
              name: "resources",
              path: "/resources",
              component: () => import("@/container/platformManage/resource.vue"),
            },
            {
              // 设置
              name: "setting",
              path: "/setting",
              component: () => import("@/container/authorization/setting.vue"),
            },
          ],
        },
        {
          path: "authorization",
          // component: (resolve) => {
          //   require(["@/container/authorization/index.vue"], resolve);
          // },
          component: () => import("@/container/authorization/index.vue"),
          redirect: "/holderList",
          children: [
            {
              // 加入租户
              name: "holderList",
              path: "/holderList",
              component: () =>
                import("@/container/authorization/workspace.vue"),
            },
            {
              // 我的申请
              name: "myApply",
              path: "/myApply",
              component: () => import("@/container/authorization/myApply.vue"),
            },
            {
              // 用户授权
              name: "userAuthorise",
              path: "/userAuthorise",
              component: () =>
                import("@/container/authorization/userAuthorise.vue"),
            },
            {
              // 数据授权
              name: "dataAuthorise",
              path: "/dataAuthorise",
              component: () =>
                import("@/container/authorization/dataAuthorise.vue"),
            },
            {
              // 数据集成执行授权
              name: "jobAuthorise",
              path: "/jobAuthorise",
              component: () =>
                import("@/container/authorization/jobAuthorise.vue"),
            },
            // {
            //   // 工作流执行授权
            //   name: "flowAuthorise",
            //   path: "/flowAuthorise",
            //   component: () => import("@/container/authorization/flowAuthorise.vue"),
            // },
            // {
            //   // DDL执行授权
            //   name: "manualAuthorise",
            //   path: "/manualAuthorise",
            //   component: () => import("@/container/authorization/manualAuthorise.vue"),
            // },
            // {
            //   // 租户管理
            //   name: "workspaces",
            //   path: "/workspaces",
            //   component: () =>
            //     import("@/container/authorization/workspace-mana.vue"),
            // },
            // {
            //   // 数据源管理
            //   name: "datasource",
            //   path: "/datasource",
            //   component: () =>
            //     import("@/container/authorization/datasource.vue"),
            // },
            // {
            //   // 数据源模板管理
            //   name: "template",
            //   path: "/template",
            //   component: () => import("@/container/authorization/template.vue"),
            // },
            // {
            //   // 资源管理器
            //   name: "resource",
            //   path: "/resource",
            //   component: () => import("@/container/authorization/resource.vue"),
            // },
            // {
            //   // 设置
            //   name: "setting",
            //   path: "/setting",
            //   component: () => import("@/container/authorization/setting.vue"),
            // },
          ],
        },
        {
          path: "data-audit",
          component: () => import("@/container/dataAudit/index.vue")
        },
        {
          path: "data-server",
          component: () => import("@/container/dataServer/index.vue"),
        },
        {
          path: "perception-map",
          component: () => import("@/container/perceptionMap/app.vue"),
        },
        {
          path: "data-model",
          component: () => import("@/container/dataModel/index.vue"),
        },
      ],
    },

    {
      path: "/login",
      component: () => import("@/container/loginUser/index.vue"),
    },
    {
      path: "/admin", // 旧版登录界面
      component: () => import("@/container/login/index.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

//  router.beforeEach((to, from, next) => {
// 	if(!/^\/login/i.test(to.path) && window.localStorage.getItem("Access-User-Token") == null) {
// 		router.history.push("/login");
// 	};
// 	next();
// });

export default router;
